/**
 * SetTriggerResult.ts
 */
export class SetTriggerResult {
    constructor(responseCode, data) {
        this.responseCode = responseCode;
        this.data = data;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=SetTriggerResult.js.map